<template>
  <v-container fluid class="maxSize">
    <v-row class="maxSize" align="center" justify="center">
      <v-col cols="12" sm="8" md="4">
        <v-card>
          <v-card-title class="text-h5 font-weight-bold Title"
            >廠商資訊平台</v-card-title
          >
          <v-divider></v-divider>
          <v-form class="pr-8 pl-8 pb-8 mb-3">
            <v-row v-show="!AdminType">
              <v-col cols="1"> </v-col>
              <v-col cols="11" class="pa-0 mt-3">
                <v-radio-group
                  v-model="Company"
                  row
                  mandatory
                  @change="SaveRadio()"
                >
                  <v-radio label="供應商" value="S"></v-radio>
                  <v-radio label="員工" value="V"></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="Account"
                  label="登入帳號"
                  prepend-icon="mdi-account"
                  required
                  outlined
                  dense
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="InputPWD"
                  label="密碼"
                  type="password"
                  prepend-icon="mdi-lock"
                  required
                  outlined
                  dense
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row v-if="!AdminType">
              <v-col cols="1"></v-col>
              <v-col>
                <VerifyCode @value-update="GetVerifyCodeState" />
              </v-col>
            </v-row>
            <v-row v-if="!AdminType">
              <v-col class="d-flex justify-center">
                <v-btn color="primary" @click="Login()" block> 登入 </v-btn>
              </v-col>
            </v-row>
            <v-row v-if="AdminType">
              <v-col class="d-flex justify-center">
                <v-btn
                  color="orange darken-4"
                  style="color: #ffffff"
                  @click="AdminLogin()"
                  block
                >
                  免驗證碼登入
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import VerifyCode from "../components/VerifyCode";
import { mapMutations, mapState } from "vuex";
import { apiLogin, apiAdminLogin } from "../utils/request/account";
import { apiAccountVerify } from "../utils/request/account";
import { Encrypt } from "../utils/AESkey.js";
import CryptoJS from "crypto-js";
export default {
  name: "Login-View",
  components: { VerifyCode },
  data: () => ({
    Account: null, //帳號
    Password: null, //加密後密碼
    Company: null, //公司別
    InputPWD: null, //輸入用密碼
    VerifyState: false, //驗證碼
    AdminType: false,
  }),
  created() {
    if (
      this.$route.query.role == process.env.VUE_APP_URL_ROLE &&
      this.$route.query.key == process.env.VUE_APP_URL_KEY
    )
      this.AdminType = true;
    //有Token去驗
    let token = localStorage.getItem("Token");
    if (localStorage.getItem("Radio"))
      this.Company = localStorage.getItem("Radio");
    if (token !== null) this.Verify();
  },
  mounted() {
    document.onkeydown = this.onKeyDown.bind(this);
  },
  destroyed() {
    document.onkeydown = null;
  },
  computed: {
    ...mapState({
      users: (state) => state.users,
    }),
  },
  watch: {},
  methods: {
    ...mapMutations({
      SetUserName: "users/SetUserName",
      SetAccount: "users/SetAccount",
      SetRouteItem: "SetRouteItem",
    }),
    //登入
    async Login() {
      if (
        !this.Account ||
        !this.InputPWD ||
        this.Account == "" ||
        this.InputPWD == ""
      ) {
        this.mixin_ShowInfoMsg("請輸入帳號密碼!");
        return;
      }

      if (!this.VerifyState) {
        this.mixin_ShowInfoMsg("請輸入正確的驗證碼!");
        return;
      }
      let iv = CryptoJS.lib.WordArray.random(8);
      this.Password = Encrypt(this.InputPWD, iv) + iv;

      let res = await apiLogin(this.Account, this.Password, this.Company);
      if (res.status != 200) return;
      localStorage.setItem("Token", res.data.accessToken);
      localStorage.setItem("RefreshToken", res.data.refreshToken);
      this.Verify();
    },
    //管理者登入
    async AdminLogin() {
      if (
        !this.Account ||
        !this.InputPWD ||
        this.Account == "" ||
        this.InputPWD == ""
      ) {
        this.mixin_ShowInfoMsg("請輸入帳號密碼!");
        return;
      }
      let iv = CryptoJS.lib.WordArray.random(8);
      this.Password = Encrypt(this.InputPWD, iv) + iv;

      let res = await apiAdminLogin(this.Account, this.Password, this.Company);
      if (res.status != 200) return;

      localStorage.setItem("Token", res.data.accessToken);
      localStorage.setItem("RefreshToken", res.data.refreshToken);
      //無安全性問題，用來判斷(帳號管理)內是否多顯示公司別
      localStorage.setItem("Admin", "1");
      this.Verify();
    },
    //驗證Token
    Verify() {
      apiAccountVerify().then((res) => {
        //設置使用者名稱、公司別
        this.SetUserName(res.data.userName);
        window.localStorage.setItem("Company", res.data.company);
        //清空appbar，根據身分重新取得
        this.SetRouteItem([]);
        this.$router.push({ name: "home" }); //跳轉主頁面
        this.mixin_ShowSuccessMsg(`歡迎${res.data.userName}`);
      });
    },
    GetVerifyCodeState(VerifyState) {
      this.VerifyState = VerifyState;
    },
    onKeyDown(e) {
      let key = e.keyCode;
      if (key === 13 && !this.AdminType) this.Login();
      else if (key === 13 && this.AdminType) this.AdminLogin();
    },
    SaveRadio() {
      localStorage.setItem("Radio", this.Company);
    },
  },
};
</script>
